import { type ModalWidth } from "components/modal";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import React from "react";
import { ModalPickerProps } from "../props";
import ShowList, { type ShowListProps } from "./ShowList";

interface Props extends ModalPickerProps<server.dto.ShowForListInternal>, Omit<ShowListProps, "onItemSelected" | "excludeKeys"> {
  buttonLabel?: string
  modalTitle?: string
  modalSize?: ModalWidth
  modalHeight?: number
  onModalClose?: () => void
}

const ShowModalPicker = (props: Props) => {
  const {
    buttonLabel,
    defaultFilter,
    initialInstruction,
    instructionOverrides,
    modalHeight,
    modalSize,
    modalTitle,
    onModalClose,
    perPage,
    queryKey,
    ...modalPickerProps
  } = props;

  return <ModalPickerWithChooseButton
    onNewClicked={() => { }}
    buttonLabel={buttonLabel ?? RESX.Buttons.btnSelect}
    modalTitle={modalTitle ?? site.currentEnvironment.show.plural}
    modalSize={modalSize ?? "small"}
    modalHeight={modalHeight ?? 600}
    onModalClose={onModalClose}
    renderModalContent={(closeModal, onChange) => <ShowList
      defaultFilter={defaultFilter}
      initialInstruction={initialInstruction}
      instructionOverrides={instructionOverrides}
      perPage={perPage}
      queryKey={queryKey}
      excludeKeys={props.excludeKeys}
      onItemSelected={(show) => {
        closeModal();
        onChange(show);
      }}
    />}
    renderRemovable={() => <></>}
    {...modalPickerProps}
  />
};

export default ShowModalPicker;
